import { render, staticRenderFns } from "./InputInboxSubmission.vue?vue&type=template&id=e4d795a6&scoped=true&"
import script from "./InputInboxSubmission.vue?vue&type=script&lang=js&"
export * from "./InputInboxSubmission.vue?vue&type=script&lang=js&"
import style0 from "./InputInboxSubmission.vue?vue&type=style&index=0&id=e4d795a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d795a6",
  null
  
)

export default component.exports